import memoize from "lodash.memoize";
import { stripUnit } from "./polished.js";
const getValueAndUnit = (value) => stripUnit(value, true);
const ONE_PX_IN_REM = 1 / 16;
export const minusOnePx = memoize((value, convertToPx) => {
    const [dimension, unit] = getValueAndUnit(value);
    switch (unit) {
        case "em":
        case "rem":
            return `${convertToPx ? dimension / ONE_PX_IN_REM - 1 : dimension - ONE_PX_IN_REM}${convertToPx ? "px" : unit}`;
        case "px":
            return `${dimension - 1}px`;
        default:
            return value;
    }
});
//# sourceMappingURL=minusOnePx.js.map